import axios from '@/plugins/axios'

// state
export const state = {
  periods: []
}

// getters
export const getters = {
  periods: state => {
    return state.periods
  }
}

// mutations
export const mutations = {
  SET_PERIODS(state, periods) {
    state.periods = periods
  },
}

// actions
export const actions = {
  async setPeriods({ commit }, periods) {
    commit('SET_PERIODS', periods)
  }
}
